import UCL from '../Helpers/UserClientLibs';

const obtenerCookieComboType = async () => {
    try {
        return await UCL.RefreshAsync();
    } catch (error) {
        console.log(error);
    }
};

export default { obtenerCookieComboType };
